import { CustomerRegister } from '@/lib/models/CustomerRegister'
import { Rally } from '@/lib/models/Rally'
import { RallyRound } from '@/lib/models/RallyRound'
import { User } from '@/lib/models/User'
import { SerializationHelper } from '@/lib/utils/SerializationHelper'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Http } from '@/lib/utils/Http'

@Module
export class LoggedInUser extends VuexModule {
    public user: User = new User();
    public hasBeenForwardedToActiveRallyRound = false

    public registerRallyRounds: CustomerRegister[] = [];

    @Mutation
    public hasBeenForwarded () {
      this.hasBeenForwardedToActiveRallyRound = true
    }

    @Mutation
    public updateLoggedInUser (user: any) {
      this.user = SerializationHelper.toInstance(new User(), user)
    }

    @Action({ commit: 'updateLoggedInUser', rawError: true })
    public async loadLoggedInUser () {
      const res = await Http.request('/api/user/logged-in')
      if (res.status !== 200) {
        return null
      }
      const userData = await res.json()
      return userData
    }

    @Mutation
    public updateRegisterRallyRounds (registerRallyRounds: any[]) {
      this.registerRallyRounds = []

      registerRallyRounds.forEach(registerRallyRound => {
        const newRegisterRallyRound = new CustomerRegister()
        newRegisterRallyRound.id = registerRallyRound.customer_register_id
        newRegisterRallyRound.customerRegisterParentId = registerRallyRound.customer_register_parent_id
        newRegisterRallyRound.status = registerRallyRound.status
        newRegisterRallyRound.urlParams = registerRallyRound.urlParams
        newRegisterRallyRound.teamnumber = registerRallyRound.teamnumber
        newRegisterRallyRound.teamId = registerRallyRound.team_id
        newRegisterRallyRound.rallyId = registerRallyRound.rally_id
        newRegisterRallyRound.rallyRoundId = registerRallyRound.rally_round_id
        newRegisterRallyRound.createdAt = registerRallyRound.created_at

        registerRallyRound.rallies.forEach((rally: any) => {
          const newRally = new Rally()
          newRally.id = rally.rally_id
          newRally.name = rally.name

          rally.rounds.forEach((rallyRound: any) => {
            const newRallyRound = new RallyRound()
            newRallyRound.id = rallyRound.rally_round_id
            newRallyRound.name = rallyRound.name
            newRallyRound.dateBegin = rallyRound.date_begin
            newRallyRound.dateEnd = rallyRound.date_end
            newRallyRound.logo = rallyRound.logo
            newRallyRound.headerImage = rallyRound.headerImage
            newRallyRound.rodeoName = rallyRound.rodeo_name
            newRally.rounds.push(newRallyRound)
          })
          newRegisterRallyRound.rallies.push(newRally)
        })

        this.registerRallyRounds.push(newRegisterRallyRound)
      })
      localStorage.setItem('logged-in-user.register-rally-rounds', JSON.stringify(this.registerRallyRounds))
    }

    @Action({ commit: 'updateRegisterRallyRounds', rawError: true })
    public async loadRegisterRallyRounds () {
      const res = await Http.request('/api/user/registers/rallies/future')
      if (res.status !== 200) {
        return null
      }

      const registerData = await res.json()
      return registerData
    }
}
